import { useMutation } from "@tanstack/react-query";
import { UserManagementModelODataResultCollection } from "api";
import { useCustomerService } from "contexts/ServiceContext";
import { ApiResponse } from "services/apiHelpers";
import { ApiStatusException } from "services/apiErrors";
import useRefetchUserManagementQueries from "../../useRefetchUserManagementQueries";

export const useVerifyEmail = (cardCode: string | undefined) => {
  const customerService = useCustomerService();

  return useMutation<
    ApiResponse<UserManagementModelODataResultCollection>,
    ApiStatusException,
    string
  >({
    mutationKey: ["verify-email-get", { cardCode }],
    mutationFn: (email: string) =>
      customerService.verifyEmailExists(email, cardCode),
  });
};

export const useCreateNewUser = () => {
  const customerService = useCustomerService();
  const refetchUserManagementList = useRefetchUserManagementQueries();

  return useMutation({
    mutationKey: ["create-new-user", "create"],
    mutationFn: ({ userDetails, permissionFlags }: UserInviteData) => {
      return customerService.createNewUser(userDetails, permissionFlags);
    },
    onSuccess: refetchUserManagementList,
  });
};

const useInviteExistingUser = (userId: string | undefined) => {
  const customerService = useCustomerService();
  const refetchUserManagementList = useRefetchUserManagementQueries();

  return useMutation({
    mutationKey: ["invite-existing-user", "create", { userId }],
    mutationFn: ({ userDetails, permissionFlags }: UserInviteData) => {
      return userId
        ? customerService.updateUserPermissions(
            userId,
            userDetails,
            permissionFlags
          )
        : Promise.reject();
    },
    onSuccess: refetchUserManagementList,
  });
};

export default useInviteExistingUser;
